import React, { Component } from 'react'
import aboutimg2 from '../../images/about2-img2.png'
import SectionHeader from './SectionHeader'


export class AboutCompanyAU extends Component {
    render() {
        return (
            <section className='bg-[#fff] mt-[32px]'>
                <div className='container flex gap-[32px] items-center p-[52px] max-[880px]:flex-col-reverse'>
                    <div className='w-1/2 max-[880px]:w-full '>
                        <div className='flex flex-col gap-[15px] items-start'>
                            <span className='text-[var(--orange)]'>Biz Kimik?</span>

                            <SectionHeader title="Rəqəmsal Həllər Üçün Etibarlı Tərəfdaşınız" className="max-w-[80%]" />
                        </div>

                        <div className='flex flex-col gap-[15px] mt-[15px]'>
                            <p className='text-[18px] text-[#555] font-[400] max-[700px]:text-[16px] max-[400px]:text-[15px]'>
                                ITnova olaraq, rəqəmsal dünyada fərq yaratmağa hədəflənən bir komandayıq. 10 ildən artıq təcrübəmizlə, müştərilərimiz üçün kreativ və funksional həllər təklif edirik. Fəaliyyət sahəmiz geniş spektri əhatə edir: veb dizayn, veb proqramlaşdırma, mobil tətbiqlərin hazırlanması, SEO xidmətləri və e-ticarət platformalarının qurulması.
                            </p>

                            <p className='text-[18px] text-[#555] font-[400] max-[700px]:text-[16px] max-[400px]:text-[15px]'>
                                Biz, müştərilərimizin ehtiyaclarına xüsusi diqqət yetirərək, onların işlərini daha effektiv və rəqabətcil hala gətirəcək layihələr yaradırıq. Komandamız, müasir texnologiyaları ən yaxşı şəkildə istifadə edərək, hər zaman yüksək keyfiyyətli və müştəri mərkəzli həllər təqdim edir. Sizin işinizin uğuru bizim prioritetimizdir və hər layihəni xüsusi olaraq dizayn edirik.
                            </p>
                        </div>
                    </div>

                    <div className='max-[880px]:w-full  max-[880px]:flex max-[880px]:justify-center'>
                        <img src={aboutimg2} className='w-[470px] h-[400px] rounded-[8px] max-[500px]:w-[380px] max-[500px]:h-auto' />
                    </div>
                </div>
            </section>
        )
    }
}

export default AboutCompanyAU